import i18n from "../i18n"

export const TYPE_LOCATION = "LOCATION";
export const TYPE_CAMERA = "CAMERA";
export const TYPE_MICROPHONE = "MICROPHONE";
export const TYPE_CAMERA_MICROPHONE = "CAMERA_MICROPHONE";


export const getPermissionNotificationType = function getType(type) {
  switch (type) {
    case TYPE_LOCATION:
      return {
        iconClass: "icon-location3",
        heading: i18n.t("alert"),
        message: i18n.t("location_enabled")
      };
    case TYPE_CAMERA:
      return {
        iconClass: "icon-camera",
        heading: i18n.t("alert"),
        message: i18n.t("alert_permission_msg")
      };
    case TYPE_MICROPHONE:
      return {
        iconClass: "icon-mic",
        heading: i18n.t("alert"),
        message: i18n.t("microphone_permission")
      };
    case TYPE_CAMERA_MICROPHONE:
      return {
        iconClass: "icon-info2",
        heading: i18n.t("alert"),
        message: i18n.t("camera_permission")
      };
    default:
      return {
        iconClass: "icon-info2",
        heading: i18n.t("alert"),
        message: i18n.t("permission_denied")
      };
  }
}


// WEBPACK FOOTER //
// ./src/constants/permission-notification.js